"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.usePausePlay = void 0;
var react_1 = require("react");
var launch_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/launch.icon.svg"));
var pause_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/pause.icon.svg"));
var usePausePlay = function (videoRef) {
    var _a = (0, react_1.useState)(false), isPaused = _a[0], setPaused = _a[1];
    return {
        toggle: function () {
            if (!videoRef.current)
                return;
            if (videoRef.current.paused) {
                setPaused(false);
                videoRef.current.play();
            }
            else {
                setPaused(true);
                videoRef.current.pause();
            }
        },
        icon: isPaused ? launch_icon_svg_1["default"] : pause_icon_svg_1["default"],
        label: isPaused ? "Play animation" : "Pause animation"
    };
};
exports.usePausePlay = usePausePlay;
//# sourceMappingURL=usePausePlay.js.map